import React from 'react';

function Alert(){
    window.confirm('Redirecting..');
    window.open("#page-search");
}

function Header() {
    return (
        <div className='main-bg'>
        <div className='main-heading' id='heading-box'>
            <h1>BLOCK BUSTER <span>Movies</span> !</h1>
            <p className='details'>NetFlix Clone Presenting you all new Awesome Movies &amp; Series on your Touch!</p>
            <div class="header-btns">
                <a href="#" target="_top">
                <button onClick={Alert} className='header-btn'>BROWSE &nbsp;&#9655;</button></a>
                <a className='close'></a>
            </div>
        </div>
        </div>
    );
}

export default Header;
